module.exports = (__webpack_require__("49fU"))(3);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/prop-types/index.js from dll-reference vendor_library
// module id = KSGD
// module chunks = 23